import Modal from 'react-bootstrap/Modal';
import {useEffect, useState} from "react";
import {SettingService} from "./Service";
import {toast} from "react-hot-toast";
import $ from "jquery";
import XConstants from "../../core/config/Constants";

const ExpenseCategorySetting = () => {
    const [service] = useState(new SettingService());
    const [show, setShow] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [id, setId] = useState(0);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const result = await service.addExpenseCategory({
            name: name,
            description: description
        });
        if (result) {
            setShow(false);
            setName('');
            setDescription('');
            toast.success('Expense category added successfully');
            getItems();
        }
    }

    const handleUpdate = async (e: any) => {
        e.preventDefault();
        const result = await service.updateExpenseCategory({
            id: id,
            name: name,
            description: description
        });
        if (result) {
            setShow(false);
            setName('');
            setDescription('');
            setId(0);
            toast.success('Expense category updated successfully');
            getItems();
        }
    }

    const getItems = () => {
        try {
            $('#items').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token');
        $('#items').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {
                    "render": function (data: string, type: any, row: any) {
                        if (data === 'Active') {
                            return `<p class="badge bg-success p-2 rounded-3">Active</p>`;
                        } else {
                            return `<p class="badge bg-danger p-2 rounded-3">Inactive</p>`;
                        }
                    },
                    "targets": 3
                },
                {

                    "render": function (data: any, type: any, row: string[]) {
                        if (row[3] === 'Active') {
                            return `<button class="btn btn-danger">Deactivate</button>`;
                        } else {
                            return `<button class="btn btn-success">Activate</button>`;
                        }
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            const status = rowData[3] === 'Active' ? 'Inactive' : 'Active'
                            const res = await service.updateExpenseCategory({
                                id: rowData[5],
                                status: status
                            });
                            if (res) {
                                toast.success("Tax type updated successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 5
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-primary">Details</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click((e: any) => {
                            setId(rowData[6]);
                            setName(rowData[1]);
                            setDescription(rowData[2]);
                            setShow(true);
                        })
                    },
                    "targets": 6
                },
                {

                    "render": function (data: any, type: any, row: any) {
                        return `<button class="btn btn-danger">Delete</button>`;
                    },
                    "createdCell": (td: any, cellData: any, rowData: any, row: any, col: any) => {
                        $(td).click(async (e: any) => {
                            const res = await service.updateExpenseCategory({
                                id: rowData[7],
                                deleted: true
                            });
                            if (res) {
                                toast.success("Tax type deleted successfully", {});
                                getItems();
                            }
                        })
                    },
                    "targets": 7
                },
            ],
            ajax: {
                url: `${XConstants.baseUrl}/company/setting/expense-category/list`,
                type: 'POST',
                contentType: 'application/json',
                headers: {
                    'Authorization': token,
                },
                data: function (d: any) {
                    return JSON.stringify({
                        ...d,
                    });
                },
            },
        });
    };

    useEffect(() => {
        getItems();
    }, []);

    return (
        <>
            <div className="card">
                <div className="card-body w-100">
                    <div className="content-page-header p-0">
                        <h5>Expense Categories</h5>
                        <div className="list-btn">
                            <a
                                href="javascript:void(0);"
                                className="btn btn-primary"
                                onClick={() => {
                                    setShow(true);
                                }}
                            >
                                <i className="fa fa-plus-circle me-2" aria-hidden="true"/>
                                Expense Categories
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-table">
                                <div className="card-body">
                                    <div className="table-responsive no-pagination">
                                        <table className="table table-center table-hover datatable" id="items">
                                            <thead className="thead-light">
                                            <tr>
                                                <th>Id</th>
                                                <th>Name</th>
                                                <th>Description</th>
                                                <th>Status</th>
                                                <th>Added Date</th>
                                                <th>Change Status</th>
                                                <th>Details</th>
                                                <th>Delete</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal fade ${show ? 'show' : ''}`}
                style={{display: 'block', position: 'initial'}}
            >
                <Modal.Dialog>
                    <form onSubmit={id === 0 ? handleSubmit : handleUpdate} className="modal-content border-0">
                        <div className="modal-header border-0 pb-0">
                            <div className="form-header modal-header-title text-start mb-0">
                                <h4 className="mb-0">{id === 0 ? 'Add' : 'Update'} Expense Category</h4>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    setName('');
                                    setDescription('');
                                    setShow(false);
                                }}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter name"
                                            value={name}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                            required={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="input-block mb-3">
                                        <label>Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter description"
                                            value={description}
                                            onChange={(e) => {
                                                setDescription(e.target.value);
                                            }}
                                            required={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer add-tax-btns">
                            <a href="javascript:void(0);" data-bs-dismiss="modal" className="btn add-btn-cancel-btn"
                               onClick={() => {
                                   setName('');
                                   setDescription('');
                                   setShow(false);
                               }}>
                                Cancel
                            </a>
                            <button
                                type="submit"
                                className="btn btn-primary add-tax-save-btn"
                                onClick={(e) => {
                                    setShow(false);
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </form>

                </Modal.Dialog>
            </div>
        </>

    );
}

export default ExpenseCategorySetting;
